// components/HomeThirdBannerManagerUI.tsx
import React, { FormEvent } from 'react';
import { InputText } from 'src/components/InputText';
import { InputFile } from 'src/components/InputFile';
import { Button } from 'src/components/Button';
// import { CarouselBannerUI } from 'src/components/CarouselBanner';
import { FormInputBannerService } from 'src/features/admin/types';
import { UseFormReturn } from 'src/hooks';
import { Banners } from 'src/model/Banners';
import { NameFiles } from '..';
import { BannerList } from 'src/components/BannerList';

interface HomeThirdBannerManagerUIProps
  extends Pick<UseFormReturn, 'formData' | 'formErrors' | 'onChangeFormInput'> {
  formNameFilesService?: NameFiles;
  onSubmitRegister: (e: FormEvent) => void;
  onChangeFormFileInputService: (
    inputName: string
  ) => (file: File | undefined) => void;
  //   onEditBanner: (id: string) => void;
  onRemoveBanner: (id: string) => void;
  banners: Banners[];
}

export const HomeThirdBannerManagerUI: React.FC<
  HomeThirdBannerManagerUIProps
> = ({
  banners,
  formData,
  formNameFilesService,
  formErrors,
  onSubmitRegister,
  onChangeFormInput,
  onChangeFormFileInputService,
  //   onEditBanner,
  onRemoveBanner,
}) => {
  const imageRef64Service = React.useRef<HTMLInputElement>(null);

  return (
    <div className="px-2 mb-4 space-y-2 grid grid-cols-1 ">
      <form onSubmit={onSubmitRegister} className="space-y-4">
        <InputText
          name="altTextService"
          label="Texto Alternativo"
          placeholder="Digite o texto alternativo..."
          value={formData[FormInputBannerService.altTextService]}
          onChange={(e) =>
            onChangeFormInput(FormInputBannerService.altTextService)(
              e.target.value
            )
          }
          error={formErrors.altTextService && formErrors.altTextService[0]}
          inputClassName="rounded-lg p-2 w-full bg-[#fafafa] shadow-inner"
        />

        <InputFile
          refInput={imageRef64Service}
          name="imageService"
          label="Upload da Imagem"
          fileName={formNameFilesService?.imageService}
          onChange={(e) =>
            onChangeFormFileInputService(FormInputBannerService.imageService)(
              e.target.files?.[0]
            )
          }
          error={formErrors.imageService && formErrors.imageService[0]}
          wrapperClass="file:border file:border-gray-300 file:rounded file:px-4 file:py-2"
        />

        <InputText
          name="linkService"
          type="text"
          label="Link"
          placeholder="Digite o Link..."
          value={formData[FormInputBannerService.linkService]}
          onChange={(e) =>
            onChangeFormInput(FormInputBannerService.linkService)(
              e.target.value
            )
          }
          error={formErrors.linkService && formErrors.linkService[0]}
          inputClassName="rounded-lg p-2 w-full bg-[#fafafa] shadow-inner"
          maxLength={10000}
        />

        <Button
          type="submit"
          title="Salvar Banner"
          buttonStyle="red"
          size="lg"
        />
      </form>

      {/* Exibição dos banners inseridos */}
      <div className="overflow-x-auto pb-4">
        <div className="grid grid-rows-2 gap-4 auto-cols-[minmax(100px,_200px)] grid-flow-col">
          {banners.map((banner) => (
            <div
              key={banner.id}
              className="relative border p-4 rounded-lg shadow-md"
            >
              <img
                src={banner.image}
                alt={banner.altText}
                className="w-full h-32 object-contain rounded mb-2"
              />
              <p className="text-center text-sm">{banner.altText}</p>
              <div className="flex justify-between mt-2">
                {/* <button
                onClick={() => onEditBanner(banner.id)}
                className="text-yellow-500"
              >
                Editar
              </button> */}
                <button
                  onClick={() => onRemoveBanner(banner.id)}
                  className="text-red-500"
                >
                  Excluir
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Componente Carousel exibindo os banners */}
      {/* <CarouselBannerUI slides={banners} /> */}
      <BannerList bannerListData={banners} />
    </div>
  );
};
